module.exports = __webpack_public_path__ + "img/03fe9ba.jpg";